import { Modal } from "pepsico-ds";
import PropTypes from "prop-types";
import JsonFormsWrapper from "../../../components/jsonForms/jsonFormsWrapper/JsonFormsWrapper";
import { keywordFormSchema, keywordUISchema } from "./keywordFormSchema";
import "./keywordManagement.scss";

const KeywordModal = ({
  isOpen,
  mode,
  formData,
  isLoading,
  onClose,
  onSubmit,
  onFormChange,
}) => {
  if (!isOpen) return null;

  const title =
    mode === "delete"
      ? "Delete Keyword"
      : mode === "edit"
        ? "Edit Keyword"
        : "Add Keyword";
  const primaryButtonText =
    mode === "delete" ? "Confirm" : mode === "edit" ? "Update" : "Create";

  const handlePrimaryAction = async () => {
    await onSubmit();
  };

  const handleFormDataChange = (data, errors) => {
    onFormChange(data, errors);
  };

  return (
    <Modal
      showModal={isOpen}
      type="S"
      title={title}
      onCloseModal={onClose}
      primaryButtonProps={{
        size: "medium",
        text: primaryButtonText,
        variant: mode === "delete" ? "danger" : "primary",
        onClick: handlePrimaryAction,
        disabled: isLoading,
        loading: isLoading,
      }}
      secondaryButtonProps={{
        size: "medium",
        text: "Cancel",
        variant: "secondary",
        onClick: onClose,
        disabled: isLoading,
      }}
      showTertiaryButton={false}
      showLink={false}
      className="keyword-modal"
    >
      <div className="keyword-modal-content">
        {mode === "delete" ? (
          <div className="delete-confirmation">
            <p>
              Are you sure you want to delete the keyword &quot;{formData?.name}
              &quot;?
            </p>
            <p className="warning-text">This action cannot be undone.</p>
          </div>
        ) : (
          <JsonFormsWrapper
            jsonschema={keywordFormSchema}
            uischema={keywordUISchema}
            data={formData}
            onChange={handleFormDataChange}
            readonly={isLoading}
          />
        )}
      </div>
    </Modal>
  );
};

KeywordModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  mode: PropTypes.oneOf(["add", "edit", "delete"]).isRequired,
  formData: PropTypes.object.isRequired,
  formErrors: PropTypes.array,
  isLoading: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onFormChange: PropTypes.func.isRequired,
};

export default KeywordModal;
